import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userClearLogOut, userLogOut } from "../hooks/local/userReducer";
import { showErrorMessage } from "../hooks/constants";

const LogoutTimer = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const timeoutRef = useRef(null);
  
  // 15 minutes in milliseconds
  const IDLE_TIME = 15 * 60 * 1000; 

  const logout = () => {
    dispatch(userLogOut());
    dispatch(userClearLogOut());
    showErrorMessage("You have been logged out due to inactivity. Please sign in again.");
  };

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(logout, IDLE_TIME);
  };

  useEffect(() => {
    // Only run the timer if the user is authenticated
    if (isAuthenticated) {
      const events = [
        "mousedown",
        "mousemove",
        "keypress",
        "scroll",
        "touchstart",
      ];

      const handleActivity = () => resetTimer();

      // Add event listeners for all activity types
      events.forEach((event) =>
        window.addEventListener(event, handleActivity)
      );

      // Initialize the timer
      resetTimer();

      return () => {
        // Clean up listeners and timeout
        events.forEach((event) =>
          window.removeEventListener(event, handleActivity)
        );
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }
  }, [isAuthenticated, dispatch]);

  return null;
};

export default LogoutTimer;

